import { Box, Container, Link, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { version } from '../package.json'

export default function Footer() {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const localeForURL = language === 'es' ? 'es' : 'en'
  const termsConditionsURL = `https://www.povertystoplight.org/${localeForURL}/terms-and-conditions`
  const privacyURL = `https://www.povertystoplight.org/${localeForURL}/privacy-policy`

  return (
    <Box
      component="footer"
      bgcolor="common.white"
      color="text.secondary"
      sx={{ borderTop: '1px solid', borderColor: 'divider' }}
    >
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          gap={{ xs: 1.5, md: 2 }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          py={{ xs: 2, md: 3 }}
        >
          <Typography
            variant="body2"
            sx={{ fontSize: { xs: '0.875rem', md: '1rem' }, lineHeight: 1.5 }}
          >
            {t('footer.copyright', { year: new Date().getFullYear() })} v
            {version}
          </Typography>

          <Stack direction="row" gap={{ xs: 2.5, md: 3 }} flexWrap="wrap">
            <Link
              variant="body2"
              underline="always"
              href={privacyURL}
              target="_blank"
              rel="noreferrer"
              sx={{ color: 'success.dark', whiteSpace: 'nowrap' }}
            >
              {t('footer.privacy')}
            </Link>
            <Link
              variant="body2"
              underline="always"
              href={termsConditionsURL}
              target="_blank"
              rel="noreferrer"
              sx={{ color: 'success.dark', whiteSpace: 'nowrap' }}
            >
              {t('footer.terms')}
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}
